import { SystemPreferencesResponse } from 'types';

/** Prefer API system preferences; fall back to client config when missing or unavailable. */
export const resolveContactPhone = (
  sysPrefs: SystemPreferencesResponse | null | undefined,
  fallback: string
): string => {
  const fromPrefs = sysPrefs?.contact_phone?.trim();
  if (fromPrefs) return fromPrefs;
  return fallback.trim();
};
